import React from 'react';
import { ReactComponent as LastPageIcon } from '../assets/last_page.svg';
import { ReactComponent as NextPageIcon } from '../assets/next_page.svg';
import { ReactComponent as EllipseIcon } from '../assets/ellipse.svg';

type ContentNavigationProps = {
  allowUserNavigation: boolean;
  first: () => void;
  pause: () => void;
  resume: () => void;
  next: () => void;
  previous: () => void;
  viewEnd: () => void;
  isPaused: boolean;
  isReviewingAfterEnded: boolean;
};

const ContentNavigation: React.FC<ContentNavigationProps> = ({
  allowUserNavigation,
  pause,
  resume,
  next,
  previous,
  viewEnd,
  isPaused,
  isReviewingAfterEnded
}) => {
  if (!allowUserNavigation) {
    return null;
  }
  return (
    <>
      <div className={`footer-toolbar show`}>
        <button
          className="icon-button prev-icon"
          title="Previous"
          onClick={previous}
        >
          <LastPageIcon />
        </button>
        {/*<button
          className="icon-button first-icon"
          title="First"
          onClick={first}
        >
          <LastPageIcon />
        </button>
        <button
          className="icon-button prev-icon"
          title="Previous"
          onClick={previous}
        >
          ⬅️
        </button>
        <button className="icon-button next-icon" title="Next" onClick={next}>
          ➡️
        </button>
        {!isPaused && (
          <button
            className="icon-button pause-icon"
            title="Pause"
            onClick={pause}
          >
            ⏸️
          </button>
        )}
        {isPaused && (
          <button
            className="icon-button pause-icon"
            title="Resume"
            onClick={resume}
          >
            ▶️
          </button>
        )}*/}
        {!isReviewingAfterEnded && (
          <button
            className={`icon-button pause-icon ${isPaused && 'is-paused'}`}
            title={`${isPaused ? 'Resume' : 'Pause'}`}
            onClick={isPaused ? resume : pause}
          >
            {!isPaused && (
              <>
                <EllipseIcon /> Following live
              </>
            )}
            {isPaused && 'Follow live'}
          </button>
        )}
        {isReviewingAfterEnded && (
          <button
            className="icon-button pause-icon is-paused"
            title="Return to end"
            onClick={viewEnd}
          >
            Return to end
          </button>
        )}
        <button
          disabled={!isPaused}
          className="icon-button live-icon"
          title="Live"
          onClick={next}
        >
          <NextPageIcon />
        </button>
      </div>
    </>
  );
};

export default ContentNavigation;
